import { ProfileStudents } from "@/pages/profiel/ProfileStudents"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/profiel/gekoppelde-cursisten/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <ProfileStudents />
}
